export default "__VITE_ASSET__BWWsnWbx__"